function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirtable = function SvgAirtable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M228.66 47.38 37.85 126.31c-10.65 4.35-10.51 19.49.14 23.69l191.65 75.99a70.6 70.6 0 0 0 52.43 0L473.72 150c10.65-4.21 10.8-19.35.14-23.69l-190.8-78.93c-17.53-7.29-37.01-7.29-54.4 0",
    style: {
      fill: "#ffbf00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.82 267.49v189.83c0 8.97 9.11 15.14 17.52 11.92l213.52-82.86c4.91-1.96 8.13-6.59 8.13-11.92V184.64c0-8.97-9.11-15.14-17.52-11.92l-213.52 82.86c-4.9 1.96-8.13 6.58-8.13 11.91",
    style: {
      fill: "#26b5f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.91 277.31-63.37 30.56-6.45 3.08-133.74 64.07C10.94 379.09 0 372.92 0 363.53V185.34c0-3.36 1.68-6.31 4.07-8.55.98-.98 2.1-1.82 3.22-2.38 3.22-1.96 7.71-2.38 11.64-.84L221.8 253.9c10.37 4.06 11.21 18.5 1.11 23.41",
    style: {
      fill: "#ed3049"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 172.58c-2.52 0-4.91.7-6.73 1.82-1.12.7-2.24 1.4-3.22 2.38l155.2 131.08 63.37-30.56c4.77-2.38 7.15-6.87 7.15-11.36 0-4.91-2.8-9.95-8.13-12.06L19.07 173.56c-1.55-.7-3.23-.98-4.77-.98",
    style: {
      fill: "#b22437"
    }
  }));
};
export default SvgAirtable;